export const contactsData = {
    email: 'shivarahul319@gmail.com',
    phone: '+1 (302) 765-8179',
    address: 'Dallas, Texas, United States - 75070 ',

    sheetAPI: ''
}